export default __webpack_public_path__ + "static/media/spring-solar-bg.4b3801a5.jpeg";